// extracted by mini-css-extract-plugin
export var active = "_bm-2";
export var highlight = "_bm-1";
export var highlightLayer = "_bm-0";
export var issuePopover = "_bm-3";
export var statusIcon = "_bm-4";